'use client';

import Link from 'next/link';

interface CTAButtonProps {
  href: string;
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  className?: string;
  onClick?: () => void;
}

const CTAButton = ({ 
  href, 
  children, 
  variant = 'primary',
  className = '',
  onClick 
}: CTAButtonProps) => {
  const baseStyles = `
    inline-flex items-center justify-center
    h-12 px-8 rounded-xl
    font-body text-base font-semibold
    transition-luxury
    focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2
    active:scale-[0.97]
    hover:-translate-y-[2px]
  `;

  const variantStyles = {
    primary: `
      bg-accent text-accent-foreground
      hover:bg-accent/90 hover:shadow-luxury-md
      shadow-luxury-sm
    `,
    secondary: `
      bg-primary text-primary-foreground
      hover:bg-primary/90 hover:shadow-luxury-md
      shadow-luxury-sm
    `,
  };

  return (
    <Link
      href={href}
      onClick={onClick}
      className={`${baseStyles} ${variantStyles[variant]} ${className}`}
    >
      {children}
    </Link>
  );
};

export default CTAButton;